module.exports = __webpack_public_path__ + "media/images/emblems/Baerschwil-blason-f2ce8f4b64224d1a92f9831aaaa560d1.png";